import { Location, LocationDescriptorObject } from 'history';
import queryString from 'query-string';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { FeatureType } from 'common/types';

export type InsightSubRoutesParam = {
  feature: FeatureType;
  slug: string;
  brandId: string;
};

export const preservePeriodParam =
  (link: string) =>
  (location: Location): LocationDescriptorObject => ({
    pathname: link,
    search: queryString.pick(location.search, ['period']),
  });

export const useInsightSubRoutes = () => {
  const { url } = useRouteMatch();
  const [baseLink] = url.split('/insights');

  return useMemo(
    () => ({
      indexLink: preservePeriodParam(`${baseLink}/insights`),
      menuLink: preservePeriodParam(`${baseLink}/insights/menu`),
      operationsLink: preservePeriodParam(`${baseLink}/insights/operations`),
      rejectedPurchasesLink: preservePeriodParam(`${baseLink}/insights/operations/rejected-purchases`),
      performanceLink: preservePeriodParam(`${baseLink}/insights/performance`),
      customerBaseLink: preservePeriodParam(`${baseLink}/insights/customer-base`),
      ratingsAndReviewsLink: preservePeriodParam(`${baseLink}/insights/ratings`),
      reports: {
        indexLink: preservePeriodParam(`${baseLink}/insights/reports`),
        newLink: preservePeriodParam(`${baseLink}/insights/reports/new`),
      },
    }),
    [baseLink],
  );
};
